import React from 'react';
import './Classes.css';
import { FaArrowDown } from "react-icons/fa";
import { Link } from 'react-router-dom';

const youtubeVideos = [
  {
    title: "Introduction to Vedic Astrology",
    url: "https://www.youtube.com/embed/tU5Ua3c4YHU"
  },
  {
    title: "Basics of Bhrigu Nandi Nadi",
    url: "https://www.youtube.com/embed/s9jwbzqYe94"
  },
  {
    title: "Numerology & Mobile Number Secrets",
    url: "https://www.youtube.com/embed/fuLjPtIGKGo"
  },
  // Add more as needed
];

const Classes = () => {
  return (
    <div className="services-classes-page">
      <header className="page-hero">
        <h1>🕉 Astrology Services & Classes</h1>
        <p>Explore powerful services and free astrology classes rooted in ancient Vedic wisdom.</p>
      </header>

      <section className="services-section">
        <h2>🔮 Our Astrology Services</h2>
        <div className="services-grid">
          <div className="service-item">🌠 Horoscope Reading</div>
          <div className="service-item">💑 Marriage & Relationship</div>
          <div className="service-item">👶 Childbirth & Family Planning</div>
          <div className="service-item">🏡 Vastu Consultation</div>
          <div className="service-item">⚖️ Legal & Debt Issues</div>
          <div className="service-item">✈️ Foreign Travel Guidance</div>
          <div className="service-item">📱 Name / Number Astrology</div>
          <div className="service-item">🧘 Personalized Remedies & Puja</div>
        </div>
      </section>

      <section className="classes-section">
        <h2>📚 Free Astrology Classes</h2>
        <p>Learn Bhrigu Nandi Nadi, Lal Kitab, Vastu, Numerology, and more – guided by experienced astrologers. Completely free and beginner friendly.</p>
        <div className="class-cards">
          {youtubeVideos.map((video, index) => (
            <div className="class-card" key={index}>
              <iframe
                width="100%"
                height="215"
                src={video.url}
                frameBorder="0"
                allowFullScreen
                title={video.title}
              ></iframe>
              <h4>{video.title}</h4>
            </div>
          ))}
        </div>
      </section>

      <section className="cta-section">
        <h3>🙏 Ready to Begin Your Journey?</h3>
        <p>Consult our experts or start learning for free. Unlock the secrets of your destiny.</p>

         
       
         <Link to="/contact" className="contact-btn">Contact Us</Link>
      </section>
    </div>
  );
};

export default Classes;
